import { Skeleton, Typography } from "@mui/material";
import {
  ArrowBackIosNewRounded,
  Box,
  CustomIconButton,
  MuiLoadingButton,
} from "components/common";
import CustomCounter from "components/common/custom-counter/CustomCounter";
import useCartFunctions from "hooks/use-cart";
import { useState } from "react";
import { useDealerSwitchState } from "states/dealerSwitchState";
import useFunctions from "../ts/useFunctions";
export default function ProductDetailsLeftSide() {
  const { loading, data, onBackClick, id } = useFunctions();
  const { title, images, wholesale_price, retail_price } = data;
  const { cart, addToCart } = useCartFunctions();

  const [quantity, setQuantity] = useState<number>(1);
  // const [addToCart, setToCart] = useState("false");
  const [dealerSwitch, setDealerSwitch] = useDealerSwitchState();

  const handleIncrement = () => {
    setQuantity((prevQuantity) => prevQuantity + 1);
  };

  const handleDecrement = () => {
    setQuantity((prevQuantity) => (prevQuantity > 1 ? prevQuantity - 1 : 1));
  };

  const disabled = dealerSwitch ? !wholesale_price : !retail_price;

  return loading ? (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <Box
        sx={{
          fontSize: "32px",
        }}
      >
        <Skeleton />
      </Box>
      <Box
        sx={{
          fontSize: "30px",
          width: "40%",
          span: {
            bgcolor: "#00E852",
          },
        }}
      >
        <Skeleton />
      </Box>
      <Box sx={{ mt: 1 }}>
        <Skeleton sx={{ mb: 1, width: "90%" }} />
        <Skeleton sx={{ width: "50%" }} />
      </Box>
      <Box sx={{ mt: 1 }}>
        <Skeleton sx={{ width: "60%", mb: 1 }} />
        <Skeleton sx={{ width: "70%", mb: 1 }} />
        <Skeleton sx={{ width: "40%" }} />
      </Box>
    </Box>
  ) : (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        textAlign: { xs: "center", md: "start" },
      }}
    >
      {/* <Box display={{ xs: "none", md: "block" }}>
        <CustomIconButton color="primary" onClick={onBackClick}>
          <ArrowBackIosNewRounded />
        </CustomIconButton>
      </Box> */}
      <Box
        sx={{
          color: "#666666",
          fontSize: "32px",
          fontWeight: "500",
        }}
      >
        {data?.title}
      </Box>
      <Box
        sx={{
          fontSize: "30px",
          color: disabled ? "rgba(0, 0, 0, 0.26)" : "#00E852",
          fontWeight: "600",
        }}
      >
        {disabled
          ? "Price unavailable"
          : `$${dealerSwitch ? wholesale_price : retail_price}`}
      </Box>
      {/* <Box
        sx={{
          color: "#666666",
          fontSize: "24px",
          fontWeight: "500",
        }}
      >
        {data?.description}
      </Box> */}
      <Box>
        <Box>
          <span style={{ color: "#666666" }}>Stock:</span>&nbsp;
          <Typography
            component="span"
            variant="body2"
            color={data?.stock === "out_stock" ? "error" : "success"}
          >
            {data?.stock === "out_stock" ? "Out of Stock" : "In Stock"}
          </Typography>
        </Box>
        <Box>
          <span style={{ color: "#666666" }}>SKU:</span>&nbsp;
          <Typography
            component="span"
            sx={{ textTransform: "uppercase" }}
            variant="body2"
          >
            {data?.sku}
          </Typography>
        </Box>
        <Box>
          <span style={{ color: "#666666" }}>Category:</span>&nbsp;
          <Typography
            component="span"
            sx={{ textTransform: "uppercase" }}
            variant="body2"
          >
            {data?.category}
          </Typography>
        </Box>
        <Box>
          <span style={{ color: "#666666" }}>Brand:</span>&nbsp;
          <Typography
            component="span"
            sx={{ textTransform: "uppercase" }}
            variant="body2"
          >
            {data?.brand}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          py: "16px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            marginBottom: "30px",
            display: { xs: "flex" },
            flexDirection: "column",
            alignItems: { xs: "center", md: "start" },
            justifyContent: { xs: "space-between" },
            gap: "30px",
          }}
        >
          <Box>
            <CustomCounter
              handleDecrement={handleDecrement}
              handleIncrement={handleIncrement}
              quantity={quantity}
              disableDec={quantity <= 1}
              disabled={disabled || data?.stock === "out_stock"}
            />
          </Box>

          <Box>
            <MuiLoadingButton
              disabled={disabled || data?.stock === "out_stock"}
              onClick={() =>
                addToCart({
                  id: Number(id),
                  price: dealerSwitch ? wholesale_price : retail_price,
                  title,
                  quantity,
                  subtotal:
                    (dealerSwitch ? wholesale_price : retail_price) * quantity, // calculate subtotal
                  data: data as any,
                })
              }
            >
              {disabled
                ? "Unavailable"
                : data?.stock === "out_stock"
                ? "Out of Stock"
                : "Add to cart"}
            </MuiLoadingButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
